module.exports = __webpack_public_path__ + "4e244b5e41e44bb8c347c5bba9e00569.svg";